module.exports = __webpack_public_path__ + "img/icon.34221860.png";